/**
 * components/team/TeamRoleSelect.js
 * The role dropdown for both team pages: every assignable role, each with the
 * line that says what it means, built-in and custom roles grouped apart.
 * Built on components/ui/AppSelect, so it looks like every other dropdown.
 */
import React, { useMemo } from "react";
import { AppSelect } from "../ui/index.js";

const TeamRoleSelect = ({
  roles,
  value,
  onChange,
  legacyKey,
  size,
  block,
  disabled,
  id,
  "aria-label": ariaLabel,
}) => {
  const options = useMemo(() => {
    const assignable = (roles || []).filter((r) => r.key !== "OWNER" && r.assignable !== false);
    const hasCustom = assignable.some((r) => r.builtin === false);
    return assignable.map((r) => ({
      value: r.key,
      label: legacyKey && r.key === legacyKey ? `${r.label} (default)` : r.label,
      description: r.description || `${(r.permissions || []).length} permissions`,
      group: hasCustom ? (r.builtin === false ? "Your roles" : "Built-in roles") : undefined,
    }));
  }, [roles, legacyKey]);

  return (
    <AppSelect
      id={id}
      aria-label={ariaLabel || "Role"}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      options={options}
      size={size}
      block={block}
      disabled={disabled}
      menuMinWidth={300}
    />
  );
};

export default TeamRoleSelect;
